import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";

interface IProps {
    invoiceFilter: InvoiceTrackingFilter,
    setReqFilter: (invoiceFilter: InvoiceTrackingFilter) => void,
    singleData?: any,
    toast: any,
    byPO_ID: boolean,
    inProcess?: boolean
};

export interface InvoiceTrackingFilter {
    year?: Date | null,
    month?: Date | null,
    // vendor_Company?: IClientCompanyDropdown | null,
    prime_Vendor_Billing_Cycle?: number | null,
    invoiceStatus?: number | null,
    primeVendorPaymentStatus?: string | null,
    paymentStatus?: string | null,
    consultant?: any | string | null
    subVendor_Company?: string | null | any,
    fromDate?: Date | null,
    toDate?: Date | null,
    Company?: number | null,
    Branch?: number | null,
    SM?: number | null,
    Recruiter?: number | null,
    dueDateFrom?: Date | null,
    dueDateTo?: Date | null,
    cases?: string[] | null,
    consultantName?: string | null,
}

const cases = [
    { caseName: "Overdue Invoices", caseValue: "Case_1" },
    { caseName: "PV Invoice Paid", caseValue: "Case_2" },
    { caseName: "No Overdue Invoices", caseValue: "Case_3" },
    { caseName: "PV Invoice Not Paid", caseValue: "Case_4" },
];

const schema = yup.object({
    year: yup.date().nullable(),
    month: yup.date().nullable(),
    client: yup.string().nullable(),
    prime_Vendor_Billing_Cycle: yup.string().nullable(),
    invoiceStatus: yup.string().nullable(),
    primeVendorPaymentStatus: yup.string().nullable(),
    paymentStatus: yup.string().nullable(),
    consultant: yup.object().shape({
        consultant_ID: yup.number().nullable(),
        consultant_Name: yup.string().nullable()
    }).nullable(),
    subVendor_Company: yup.object().shape({
        vendor_Company_ID: yup.number().nullable(),
        vendor_Company_Name: yup.string().nullable()
    }).nullable(),
    Company: yup.string().nullable(),
    Branch: yup.string().nullable(),
    SM: yup.number().nullable(),
    Recruiter: yup.string().nullable(),
    cases: yup.array().of(yup.string()).nullable()
});

export const Filter = (props: IProps) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [consultant, setConsultant] = useState<Array<any>>();
    const [subvendorCompany, setSubvendorCompany] = useState<Array<any>>();
    const [selectedCases, setSelectedCases] = useState<Array<{ caseName: string, caseValue: string }>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<InvoiceTrackingFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const onSubmit = (data: InvoiceTrackingFilter) => {
        data.subVendor_Company = data.subVendor_Company?.vendor_Company_Name || null;
        data.consultantName = data.consultant?.consultant_Name || null;
        let newFilter: any = data;
        newFilter.cases = selectedCases;
        props.setReqFilter(data);
    };
    const Billing_Cycle = [
        { name: "-- SELECT --", value: 0 },
        { name: "Weekly", value: 1 },
        { name: "Bi-Weekly", value: 2 },
        { name: "Monthly", value: 3 },
    ];
    // const Billing_Cycle = [
    //     { name: "-- SELECT --", value: null },
    //     { name: "Weekly", value: "Weekly" },
    //     { name: "Monthly", value: "Monthly" },
    // ];
    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "In Process", value: "In Process" },
        { name: "Released", value: "Released" },
        { name: "Released In Advance", value: "Released In Advance" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const PV_Payment_Status_BulkUpdate = [
        { name: "-- SELECT --", value: null },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Payment_Status_BulkUpdate = [
        { name: "-- SELECT --", value: null },
        { name: "Released", value: "Released" },
        { name: "Released In Advance", value: "Released In Advance" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Payment_Term = [
        { name: "Net 30" },
        { name: "Net 45" },
        { name: "Pay on Pay" },
        { name: "Net 15" },
        { name: "Net 60" },
        { name: "Net 7" }
    ];
    const Invoice_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Not Required", value: "Not Required" },
        { name: "Generated", value: "Generated" },
        { name: "Sent to Client", value: "Sent to Client" },
        { name: "Yet to Generated", value: "Yet to Generated" },
    ];

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    };

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }


    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const loadsubvendorCompany = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/sub_vendor_companies`, "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                vendor_Company_ID: 0,
                vendor_Company_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSubvendorCompany(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    }
    const completeMethodSubvendorCompany = (event: { query: string }) => {
        loadsubvendorCompany(event.query);
    }


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name === "Company") {
                if (value.Company != 0 && value.Company != null) {
                    loadSm(0, value.Company, 0);
                    loadBranch(value.Company);
                } else {
                    if (value.Company === 0 && value.Company != null) {
                        loadBranch();
                        loadRecruiters(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                        loadSm(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "Branch") {
                if (value.Branch != 0 && value.Branch != null) {
                    loadSm(value.Branch, 0, 0);
                    loadRecruiters(value.Branch, 0, 0);
                } else {
                    if (value.Branch === 0 && value.Branch != null) {
                        loadRecruiters(value.Branch, control._formValues.Company, control._formValues.Team_Name);
                        loadSm(value.Branch, control._formValues.Company, control._formValues.Team_Name);
                    }
                }
            }


        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSm(0, 0, 0);
        loadBranch();
        loadCompany();
        loadRecruiters(0, 0, 0);
    }, []);


    useEffect(() => {
        reset(props.invoiceFilter);
    }, [props.invoiceFilter]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate column={6} label="From Date" control={control} name="fromDate" />
                <JVDate column={6} label="To Date" control={control} name="toDate" />
                {/* <JVDropdownInput column={6} completeMethod={completeMethodClientCompanies} label="Vendor Company" control={control} name="vendor_Company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" /> */}
                {props.inProcess !== true && < JVDropdownInput column={6} label="Consultant Name" completeMethod={completeMethodConsultant} control={control} name="consultant" options={consultant} optionLabel="consultant_Name" placeholder="Search " />}
                <JVDropdownInput column={6} label="Sub Vendor" completeMethod={completeMethodSubvendorCompany} control={control} name="subVendor_Company" options={subvendorCompany} optionLabel="vendor_Company_Name" placeholder="Search " />
                {/* <JVDropdown column={6} label="Company Name " control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" /> */}
                {/* <JVDropdown column={6} label="Branch " control={control} name="Branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " /> */}
                {/* <JVDropdown column={6} label="S M" control={control} name="SM" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="SM" /> */}
                {/* <JVDropdown column={6} label="Recruiter" control={control} name="Recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
                <JVDropdown column={6} label="PV Payment Status" control={control} name="primeVendorPaymentStatus" options={PV_Payment_Status_BulkUpdate} optionLabel="name" optionValue="value" placeholder="Select PV Payment Status" />
                <JVDropdown column={6} label="SV Payment Status" control={control} name="paymentStatus" options={props?.inProcess === true ? Payment_Status_BulkUpdate : Payment_Status} optionLabel="name" optionValue="value" placeholder="Select SV Payment Status" />
                <JVDate column={6} label="Due Date From" control={control} name="dueDateFrom" />
                <JVDate column={6} label="Due Date To" control={control} name="dueDateTo" />
                {props.inProcess !== true && <div className="field col-2 md:col-2">
                    <p>Cases</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedCases} onChange={(e) => setSelectedCases(e.value)} options={cases} optionValue="caseValue" optionLabel="caseName" display="chip" filter placeholder="Select Cases" />
                </div>}

                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter); setSelectedCases([]) }} type="button"></Button>
                </div>
            </form>
        </>
    );
}